import {
  ERROR_INTEGRATION_SETTINGS,
  ERROR_INTEGRATION_SUGGESTION,
  RESET_INTEGRATION_SUGGESTION,
  SAVING_INTEGRATION_SETTINGS,
  SAVING_INTEGRATION_SUGGESTION,
  SUCCESS_INTEGRATION_SETTINGS,
  SUCCESS_INTEGRATION_SUGGESTION,
  UPDATE_COMPANY_RESULTS,
  UPDATE_INTEGRATION_SETTINGS,
} from '../constants/actions';

export const updateIntegrationSettings = integrationSettings => {
  return {
    type: UPDATE_INTEGRATION_SETTINGS,
    integrationSettings,
  };
};

export const savingIntegrationSettings = integrationSettings => {
  return {
    type: SAVING_INTEGRATION_SETTINGS,
    integrationSettings,
  };
};

export const successIntegrationSettings = response => {
  return {
    type: SUCCESS_INTEGRATION_SETTINGS,
    response,
  };
};

export const errorIntegrationSettings = errorMessage => {
  return {
    type: ERROR_INTEGRATION_SETTINGS,
    errorMessage,
  };
};

export const savingIntegrationSuggestion = suggestion => {
  return {
    type: SAVING_INTEGRATION_SUGGESTION,
    suggestion,
  };
};

export const successIntegrationSuggestion = response => {
  return {
    type: SUCCESS_INTEGRATION_SUGGESTION,
    response,
  };
};

export const errorIntegrationSuggestion = errorMessage => {
  return {
    type: ERROR_INTEGRATION_SUGGESTION,
    errorMessage,
  };
};

export const resetIntegrationSuggestion = () => {
  return {
    type: RESET_INTEGRATION_SUGGESTION,
  };
};

export const updateCompanyResults = results => {
  return {
    type: UPDATE_COMPANY_RESULTS,
    results,
  };
};
